import 'magnific-popup';
export default (function () {
  jQuery('.js-video-link').magnificPopup({
    type: 'iframe' // other options

  });
});